import React from 'react'

const AddSlot = () => {
  return (
    <div>AddSlot</div>
  )
}

export default AddSlot